import { render } from "./IpOsSolicitacaoStatusSelect.vue?vue&type=template&id=4e3a76e7"
import script from "./IpOsSolicitacaoStatusSelect.vue?vue&type=script&lang=js"
export * from "./IpOsSolicitacaoStatusSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__